<script setup lang="ts"></script>

<template>
  <p class="mb-4 text-sm">
    <slot></slot>
  </p>
</template>
